import { CheckCircle2, ImagePlus, XCircle } from "lucide-react"
import { useState } from "react"
import { AddReminderModal } from "@/features/my-rituality/components/AddReminderModal"
import type { InsightToolResult } from "../../types/ai-chat.types"

export function InsightSavedCard({ data }: { data: InsightToolResult }) {
  const [reminderOpen, setReminderOpen] = useState(false)

  if (!data.saved) {
    return (
      <div className="my-2 flex items-start gap-2 rounded-lg border border-red-500/20 bg-red-500/5 p-3">
        <XCircle className="mt-0.5 h-4 w-4 shrink-0 text-red-400" />
        <p className="text-xs text-foreground/70">
          Could not save your insight. Please try sharing your reflection again.
        </p>
      </div>
    )
  }

  return (
    <>
      <div className="my-2 flex items-start gap-2 rounded-lg border border-green-500/20 bg-green-500/5 p-3">
        <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-green-400" />
        <div className="flex-1">
          <p className="text-xs font-medium text-foreground">Growth insight saved</p>
          {data.reminderScheduledAt && (
            <p className="mt-0.5 text-[11px] text-foreground/50">
              Reminder scheduled for{" "}
              {new Date(data.reminderScheduledAt).toLocaleDateString("en-US", {
                month: "short",
                day: "numeric",
                hour: "numeric",
                minute: "2-digit",
              })}
            </p>
          )}
          <button
            type="button"
            onClick={() => setReminderOpen(true)}
            className="mt-2 inline-flex items-center gap-1.5 text-[11px] font-semibold text-brand-olive hover:text-brand-olive/80 transition-colors"
          >
            <ImagePlus className="size-3.5" />
            Create Reminder Card
          </button>
        </div>
      </div>

      <AddReminderModal
        open={reminderOpen}
        onOpenChange={setReminderOpen}
        defaultText={data.insightText ?? ""}
      />
    </>
  )
}
